const Config = {
    authorization: 'b026a79fd77f921f2becc243d81a0b2c'
}

export { Config } ;